import { message } from "antd";
import { ReactNode } from "react";

export const displayWarningMessage = (text: string, duration?: number | VoidFunction, onClose?: VoidFunction) => message.warning(text, duration, onClose);

export const displayErrorMessage = (text: string | ReactNode, duration?: number | VoidFunction, onClose?: VoidFunction) => message.error(text, duration, onClose);

export const displaySuccessMessage = (text: string, duration?: number | VoidFunction, onClose?: VoidFunction) => message.success(text, duration, onClose);

export const displayNotImplementedMessage = () => displayWarningMessage('Funcionalidad no implementada por el momento.');